import React, {Component} from "react";
import SimpleFormBuilder from "../forms_builder/SimpleFormBuilder";
import utils from "../../utils/utils";
import Prototypes from "prop-types";
import {adminApi} from "../../services/ApiService";
import * as Yup from "yup";
import validationHelper from "../../utils/validationHelper";
import {makeError} from "../modals/ErrorModal";
import Constants from "../../utils/constants";
import AlertConfirm from "../modals/Confirm";
import SvGraphics from "../../assets/SvGraphics";

class AdminEditForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            entry: {},
            matrix :[2,1,1,1],
            errors: {},
            errorsOnSave:{},
        };
    }

    initValidation = async () => {
        let {t} = this.props
        let validationSchema = Yup.object().shape({
            First_name:Yup.string().required(t('admin.form.first_name_req')),
            Last_name:Yup.string().required(t('admin.form.last_name_req')),
            Phone_num1:Yup.string().required(t('admin.form.phone_number_req')),
            Email:Yup.string().matches(Constants.emailRegExp, t('admin.form.email_invalid')).required(t('admin.form.email_req')),
        })
        let errors = await validationHelper.validate(this.state.entry,validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }

    async componentWillMount() {
        if (this.props && this.props.entry) await this.setState({entry:utils.removeEmptyOrNull(this.props.entry)})
        await this.initValidation()
    }

    async closeSideBar(){
        let {t} = this.props
        document.body.style.overflow = "auto"
        let confirm = await AlertConfirm({
            options:{
                title: t('admin.form.withdraw_edit_admin'),
            }},t('admin.form.withdraw_edit_admin_info'))
        if (confirm) {
            document.body.style.overflow = "auto"
            this.props.closeSideBar(false)
            this.setState({entry:null})
        } else {
            document.body.style.overflow = "hidden"
        }
    }

    async saveInfo(){
        let {t} = this.props
        let {entry} = this.state
        if (!utils.isEmpty(this.state.errors)){
            this.setState({errorsOnSave:this.state.errors});
            await makeError({
                proceedLabel: t('admin.form.ok'),
                options:{
                    title: t('admin.form.admin_not_edited'),
                }
            },[t('admin.form.fill_all_req')]);
            return;
        }
        document.body.style.overflow = "auto"
        let confirm = await AlertConfirm({
            options:{
                title: t('admin.form.edit_admin'),
            }},t('admin.form.edit_admin_confirm'))
        if (confirm) {

            entry = utils.ObjectEmptiesToNulls(entry)
            let response = await adminApi.EditAdmin(entry,entry.id)
            if (response) {
                this.props.editAdmin(entry)
                document.body.style.overflow = "auto"
                this.props.closeSideBar(false)
                this.setState({entry:{}})
            }
        } else {
            document.body.style.overflow = "hidden"
        }
    }

    onEntryChange = async event => {
        let {entry,validationSchema} = this.state
        let name = event.target.name
        let value = event.target.type === 'checkbox' ?
            !entry[name]
            : event.target.value
        utils.set(entry,name,value)
        let entryValidator = utils.removeEmptyOrNull(entry)
        let errors = await validationHelper.validate(entryValidator, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave,name)){
            utils.set(errorsOnSave,name,utils.get(errors,name))
        }
        this.setState({
            entry,
            errors,
            errorsOnSave
        })
    }

    getFields = (t) => {
        return [
            {type:'text', max: 20, name:'First_name',display: t('admin.form.first_name'), placeholder: t('admin.form.enter_first_name'), required:true, width:0.5, style:'inline'},
            {type:'text', max: 20, name:'Last_name',display: t('admin.form.last_name'), placeholder: t('admin.form.enter_last_name'), required:true, width:0.5, style:'inline'},
            {type:'phone', max: 50, name:'Phone_num1',display: t('admin.form.phone_number'), placeholder: t('admin.form.phone_number'), required:true, width:1, style:'inline'},
            {type:'text', max: 50, name:'Email',display: t('admin.form.email'), placeholder: t('admin.form.enter_email'), required:true, width:1, style:'inline'},
            {type:'checkbox', name:'TwoFA',display: t('admin.form.is_TwoFA_req'), width:1, style:'block'},
        ]
    }

    render() {
        let display = this.props.isSideBarOpen ? 'block' : 'none'
        let width = this.props.isSideBarOpen ? "600px" : "0px"
        let container_width = this.props.isSideBarOpen ? "100%" : "0px"
        let {errorsOnSave} = this.state
        let {t} = this.props
        let fields = this.getFields(t)

        return (
            <div className={"sidenav-complete"} style={{width:container_width, height:"100%"}}>
                <div className={"sidenav"} style={{width:width, height:"100%", float:'right'}}>
                    <SvGraphics onClick={this.closeSideBar.bind(this)} className={'close-bar-x'} svgname={'close'} height={'15px'} width={'15px'} style={{
                        float: 'left',
                        top: '10px',
                        left: '10px',
                        position: 'absolute',
                        cursor: 'pointer'
                    }}/>
                    <div className={'register-form-title container block'}>
                        <h3 className={'h-centered block'}>{this.props.title}</h3>
                    </div>
                    <div className={'register-form container block'}>
                        <SimpleFormBuilder
                            errors={errorsOnSave}
                            entry={this.state.entry}
                            matrix={this.state.matrix}
                            fields={fields}
                            onEntryChange={e => this.onEntryChange(e)}
                        />
                    </div>
                </div>
                <div className={'register-form-nav-container block'}  >
                    <div className={'register-form-nav'}  style={{width:width,display:'flex',justifyContent:"space-around"}}>
                        <button type={"button"} onClick={this.saveInfo.bind(this)} style={{display:display}} className={"btn btn-primary save-info"}>
                            {t('admin.hcp.form.save')}
                        </button>
                        <button type={"button"} onClick={this.closeSideBar.bind(this)} style={{display:display}} className={"btn btn-primary save-info"}>
                            {t('admin.hcp.form.close')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
AdminEditForm.propTypes = {
    isSideBarOpen:Prototypes.bool.isRequired,
    closeSideBar:Prototypes.func.isRequired,
    editAdmin:Prototypes.func.isRequired,
    title: Prototypes.string.isRequired,
    entry: Prototypes.object
}

export default AdminEditForm
